import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";



export var AddDepartmentRes;
export const addDepartmentTodo = createAsyncThunk('adminAddDepartment', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'superadmin/department',
            data: {
                "name": data?.department,
                "status": data?.status,
                "added_by": localStorage.getItem('user_id'),
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return AddDepartmentRes = res.data

    } catch (error) {
        return AddDepartmentRes = error.response.data
    }
})